module.exports = __webpack_public_path__ + "static/media/1-4-4.71885387.png";